import React from "react";

import ClearIcon from "@material-ui/icons/Clear";
import SearchIcon from "@material-ui/icons/Search";
import clsx from "clsx";
import PropTypes from "prop-types";

import RbActionsContext from "components/RbActions/RbActionsContext";

import useStyles from "./RbSearchAction.styles";

export const RbSearchAction = React.forwardRef(function RbSearchAction(
  props,
  ref
) {
  const {
    value,
    closeLabel,
    placeholder,
    onChangeValue,
    searchLabel,
    ...other
  } = props;

  const classes = useStyles();

  const inputRef = React.useRef();

  const focusTimeoutRef = React.useRef();

  const { compacted } = React.useContext(RbActionsContext);

  const [full, setFull] = React.useState(false);

  const [large, setLarge] = React.useState(false);

  const handleSerchClick = () => {
    setFull(true);
  };

  const handleClose = () => {
    setFull(false);
  };

  const handleChange = (event) => {
    if (onChangeValue) {
      onChangeValue(event.target.value);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Escape" && onChangeValue) {
      onChangeValue("");
    }
  };

  const handleFocus = () => {
    focusTimeoutRef.current = setTimeout(() => {
      setLarge(true);
    }, 500);
  };

  const handleBlur = () => {
    clearTimeout(focusTimeoutRef.current);
    setLarge(false);
  };

  React.useEffect(() => {
    if (full) {
      inputRef.current.focus();
    }
  }, [full]);

  if (compacted && !full) {
    return (
      <button
        className={classes.rootButton}
        type="button"
        onClick={handleSerchClick}
        aria-label={searchLabel}
      >
        <SearchIcon fontSize="default" className={classes.iconSvg} />
      </button>
    );
  }

  return (
    <div
      {...other}
      ref={ref}
      className={clsx(classes.root, {
        [classes.root_full]: full,
      })}
    >
      <div
        className={clsx(classes.control, {
          [classes.control_full]: full,
          [classes.control_large]: large || value,
        })}
      >
        <SearchIcon fontSize="default" className={classes.controlSearch} />
        <input
          ref={inputRef}
          className={classes.controlInput}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onFocus={handleFocus}
          onBlur={handleBlur}
          value={value}
          placeholder={placeholder}
        />
      </div>
      {full && (
        <button
          {...other}
          ref={ref}
          className={classes.closeButton}
          type="button"
          onClick={handleClose}
          aria-label={closeLabel}
        >
          <ClearIcon fontSize="default" className={classes.closeSvg} />
        </button>
      )}
    </div>
  );
});

RbSearchAction.propTypes = {
  children: PropTypes.node,
  closeLabel: PropTypes.string,
  onChangeValue: PropTypes.func,
  placeholder: PropTypes.string,
  searchLabel: PropTypes.string,
  value: PropTypes.string,
};

RbSearchAction.defaultProps = {
  children: null,
  closeLabel: "Close",
  onChangeValue: undefined,
  placeholder: undefined,
  searchLabel: "Search",
  value: undefined,
};

RbSearchAction.displayName = "RbSearchAction";

export default React.memo(RbSearchAction);
